<div class="py-4">
    <div *ngIf="isLoading; else content">
        <div class="d-flex justify-content-center py-2">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <ng-template #content>
        <form [formGroup]="carForm">
            <mat-form-field class="three-quarters-width pt-2" appearance="outline">
                <mat-label>Numer rejestracyjny:</mat-label>
                <input matInput formControlName="registration_number" name="registration_number" type="text"
                       placeholder="Numer rejestracyjny"
                       #registrationNoLength>
                <mat-hint align="end">
                    {{ registrationNoLength.value.length }} / {{ registrationNumberMaxLength }}
                </mat-hint>
                <mat-error *ngIf="registrationNumber.errors?.['required']">
                    Podaj numer rejestracyjny.
                </mat-error>
                <mat-error
                    *ngIf="registrationNumber.value.length < registrationNumberMinLength && !registrationNumber.errors?.['required']">
                    Minimalna długość wynosi {{ registrationNumberMinLength }} znaków.
                </mat-error>
                <mat-error *ngIf="registrationNumber.value.length > registrationNumberMaxLength">
                    Maksymalna długość wynosi {{ registrationNumberMaxLength }} znaków.
                </mat-error>
            </mat-form-field>
            <div class="pt-2">
                <mat-form-field class="three-quarters-width pt-2" appearance="outline">
                    <mat-label>Marka i model pojazdu:</mat-label>
                    <input matInput formControlName="car_brand" name="car_brand" type="text"
                           placeholder="Marka i model pojazdu"
                           #carBrandLength>
                    <mat-hint align="end">
                        {{ carBrandLength.value.length }} / {{ carBrandMaxLength }}
                    </mat-hint>
                    <mat-error *ngIf="carBrand.errors?.['required']">
                        Podaj markę pojazdu.
                    </mat-error>
                    <mat-error
                        *ngIf="carBrand.value.length < carBrandMinLength && !carBrand.errors?.['required']">
                        Minimalna długość wynosi {{ carBrandMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="carBrand.value.length > carBrandMaxLength">
                        Maksymalna długość wynosi {{ carBrandMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="pt-2">
                <mat-form-field class="three-quarters-width pt-2" appearance="outline">
                    <mat-label>numer VIN:</mat-label>
                    <input matInput formControlName="car_vin" name="car_vin" type="text"
                           placeholder="numer VIN"
                           #carVinLength>
                    <mat-hint align="end">
                        {{ carVinLength.value.length }} / {{ carVinMaxLength }}
                    </mat-hint>
                    <mat-error
                        *ngIf="carVin.value.length < carVinMinLength && !carVin.errors?.['required']">
                        Minimalna długość wynosi {{ carVinMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="carVin.value.length > carVinMaxLength">
                        Maksymalna długość wynosi {{ carVinMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="pt-3">
                <mat-form-field appearance="outline" color="primary">
                    <mat-label>Data produkcji:</mat-label>
                    <input matInput [matDatepicker]="productionPicker" [formControl]="production_date">
                    <mat-hint>DD/MM/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="productionPicker"></mat-datepicker-toggle>
                    <mat-datepicker #productionPicker (closed)="setProductionDate()"></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="pt-3">
                <mat-form-field appearance="outline" color="primary">
                    <mat-label>Data następnego przeglądu:</mat-label>
                    <input matInput [matDatepicker]="inspectionPicker" [formControl]="inspection_date">
                    <mat-hint>DD/MM/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="inspectionPicker"></mat-datepicker-toggle>
                    <mat-datepicker #inspectionPicker (closed)="setInspectionDate()"></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="pt-3">
                <mat-form-field appearance="outline" color="primary">
                    <mat-label>Data końca ubezpieczenia:</mat-label>
                    <input matInput [matDatepicker]="insuranceEndPicker" [formControl]="insurance_end_date">
                    <mat-hint>DD/MM/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="insuranceEndPicker"></mat-datepicker-toggle>
                    <mat-datepicker #insuranceEndPicker (closed)="setInsuranceEndDate()"></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="pt-3">
                <mat-form-field class="full-width pt-3" appearance="outline">
                    <mat-label>Opis:</mat-label>
                    <textarea matInput formControlName="description" name="description" type="text"
                              placeholder="Komentarz" #descriptionLength></textarea>
                    <mat-hint align="end">
                        {{ descriptionLength.value.length }} / {{ descriptionMaxLength }}
                    </mat-hint>
                    <mat-error
                        *ngIf="description.value.length < descriptionMinLength && !description.errors?.['required']">
                        Minimalna długość wynosi {{ descriptionMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="description.value.length > descriptionMaxLength">
                        Maksymalna długość wynosi {{ descriptionMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
    </ng-template>
</div>
